<template>
	<div class="app-container">
		<div>
			{{ loggedInUserInfo }}
		</div>
	</div>
</template>

<script>
import getUserInfo from '../../cognito/getUserInfo';

export default {
	data() {
		return {
			loggedInUserInfo: {}
		};
	},
	created() {
		getUserInfo()
			.then(({ data }) => {
				this.loggedInUserInfo = data;
			})
			.catch(e => {
				console.log(e);
			});
	}
};
</script>
